import { authenticatedCacheGeneration, requireAuthenticatedGeneration } from './authenticated-session';
import { useViewerStore } from '@/shared/store/viewer-store';

export type ModelCommandContext = Readonly<{
  modelId: string | null;
  modelEpoch: number;
  authGeneration: number;
}>;

export function captureModelCommandContext(modelId: string | null | undefined): ModelCommandContext {
  return Object.freeze({ modelId: modelId ?? null,
    modelEpoch: useViewerStore.getState().activeModelEpoch,
    authGeneration: authenticatedCacheGeneration() });
}

export function modelCommandContextIsCurrent(context: ModelCommandContext): boolean {
  const current = useViewerStore.getState();
  return context.authGeneration === authenticatedCacheGeneration()
    && !!context.modelId && current.activeModelId === context.modelId
    && current.activeModelEpoch === context.modelEpoch;
}

export function requireModelCommandContext(context: ModelCommandContext,
  modelId: string | null | undefined, code = 'MODEL_COMMAND_CONTEXT_STALE'): string {
  requireAuthenticatedGeneration(context.authGeneration);
  if (context.modelId !== modelId || !modelCommandContextIsCurrent(context)) throw new Error(code);
  return context.modelId!;
}
